import { useEffect, useState } from 'react'
import SimpleCard from 'components/SimpleCard'
import Main from 'layouts/main'
import {
  RiBookOpenLine,
  RiChatCheckLine,
  RiChatDeleteLine,
  RiFeedbackLine,
  RiQuestionnaireLine
} from 'react-icons/ri'
import { SimpleTitleCard } from 'styles/global'
import { CardBigNumbers, Colors, ContentBoard, ScrollContainer } from './style'
import {
  FiBriefcase,
  FiChevronsRight,
  FiMonitor,
  FiShoppingBag,
  FiUsers
} from 'react-icons/fi'
import CardCarteira from './components/CardCarteira'
import CardCampanha from './components/CardCampanha'
import { Card, Col, Collapse, Row } from 'reactstrap'
import InputCustom from 'components/Inputs'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { INICIO } from 'store/modules/inicio/types'
import useRedux from 'hooks/useRedux'
import * as inicioActions from 'store/modules/inicio/actions'
import * as atendimentoActions from 'store/modules/atendimento/actions'
import { adicaodeZerosNoCPF, maskCPF, removeMaskCPF } from 'util/masks'
import { ATENDIMENTO } from 'store/modules/atendimento/types'
import { validaCpf } from 'util/validations'
import { toast } from 'react-toastify'
import LoadingComponent from './components/LoadingComponent'
import moment from 'moment'
import { MdOpenInFull } from 'react-icons/md'
import PrivateComponent from 'components/PrivateComponent'
import { LOGIN } from 'store/modules/login/types'
import { IconButton } from '@mui/material'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'

function Inicio(): JSX.Element {
  const {
    cpfAtendimento,
    quantidadeLeads,
    carteiras,
    campanhas,
    loading,
    bigNumbers
  } = useSelector<ApplicationState, INICIO>((state) => state.inicio)

  const { modalCadastroCliente } = useSelector<ApplicationState, ATENDIMENTO>(
    (state) => state.atendimento
  )

  const { allowedActions } = useSelector<ApplicationState, LOGIN>(
    (state) => state.login
  )

  const { dispatch } = useRedux()

  const [openCentro, setOpenCentro] = useState<Record<string, boolean>>({})
  const [openConsultor, setOpenConsultor] = useState<Record<string, boolean>>(
    {}
  )

  function iniciarAtendimento() {
    if (validaCpf(removeMaskCPF(cpfAtendimento))) {
      dispatch(inicioActions.cleanCpfAtendimento())
      dispatch(atendimentoActions.cleanInfosFormulario())
      dispatch(
        atendimentoActions.getFormularioAtendimento30Saga(cpfAtendimento)
      )
      dispatch(
        atendimentoActions.setInfosCadastroClienteModal({
          ...modalCadastroCliente,
          cpf: cpfAtendimento
        })
      )
    } else {
      toast.warn('CPF inválido')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      iniciarAtendimento()
    }
  }

  useEffect(() => {
    dispatch(inicioActions.getCentrosCustoCarteiraSaga())
    dispatch(inicioActions.getCampanhasSaga())
    dispatch(inicioActions.getBigNumbersSaga(moment().format('YYYY-MM-DD')))
  }, [dispatch])

  useEffect(() => {
    if (allowedActions.inicio['iniciarCampanhaCrm']) {
      dispatch(inicioActions.getQuantidadeLeadsSaga())
    }
  }, [dispatch, allowedActions.inicio])

  function toggleCentro(centroCustoId: string) {
    const isOpening = !openCentro[centroCustoId]

    setOpenCentro((prev) => ({ ...prev, [centroCustoId]: isOpening }))

    if (isOpening) {
      dispatch(
        inicioActions.getConsultoresCarteiraByCentroCustoSaga(centroCustoId)
      )
    }
  }

  function toggleConsultor(consultorId: string, centroCustoId: string) {
    const isOpening = !openConsultor[`${centroCustoId}-${consultorId}`]

    setOpenConsultor((prev) => ({
      ...prev,
      [`${centroCustoId}-${consultorId}`]: isOpening
    }))

    if (isOpening) {
      dispatch(
        inicioActions.getCarteirasByConsultorSaga(consultorId, centroCustoId)
      )
    }
  }

  return (
    <Main>
      <SimpleCard>
        <SimpleTitleCard>
          <RiBookOpenLine className="icon" /> Bem-vindo, esses são seus
          agendamentos hoje
        </SimpleTitleCard>
        <LoadingComponent isLoading={loading.bigNumbers}>
          <div className="row d-flex justify-content-evenly">
            <CardBigNumbers background={Colors.blue}>
              <RiFeedbackLine className="icon" />
              <div>
                <span>{bigNumbers.agendamentos}</span>
                <label>Agendados</label>
              </div>
            </CardBigNumbers>
            <CardBigNumbers background={Colors.green}>
              <RiChatCheckLine className="icon" />
              <div>
                <span>{bigNumbers.confirmados}</span>
                <label>Confirmados</label>
              </div>
            </CardBigNumbers>
            <CardBigNumbers background={Colors.gray}>
              <RiQuestionnaireLine className="icon" />
              <div>
                <span>{bigNumbers.naoConfirmados}</span>
                <label>Não confirmados</label>
              </div>
            </CardBigNumbers>
            <CardBigNumbers background={Colors.orange}>
              <RiChatDeleteLine className="icon" />
              <div>
                <span>{bigNumbers.expirados}</span>
                <label>Expirados</label>
              </div>
            </CardBigNumbers>
          </div>
        </LoadingComponent>
      </SimpleCard>
      <Row>
        <PrivateComponent screen="inicio" typeActions="iniciarCampanhaCrm">
          <Col md={6} className="d-flex">
            <ContentBoard background={Colors.purpleGradiente} color="#FFFFFF">
              <SimpleTitleCard color="#FFFFFF" colorIcon="#FFFFFF">
                <FiMonitor className="icon" /> Campanha site
              </SimpleTitleCard>
              <div className="d-flex flex-column row-gap-20">
                <label>Iniciar um atendimento de algum lead do site</label>
                <div>
                  <span>{quantidadeLeads || 0}</span> Leads
                </div>
                <div
                  onClick={() => {
                    if (quantidadeLeads > 0) {
                      return dispatch(
                        inicioActions.iniciarAtendimentoLeadSaga()
                      )
                    }
                    return toast.warn(
                      'Campanha Site - Não há leads disponíveis.'
                    )
                  }}
                  className="btn-outline-white"
                >
                  Iniciar <FiChevronsRight />
                </div>
              </div>
            </ContentBoard>
          </Col>
        </PrivateComponent>
        <Col className="d-flex">
          <ContentBoard>
            <SimpleTitleCard>
              <FiBriefcase className="icon" /> Iniciar um atendimento
            </SimpleTitleCard>
            <div className="d-flex flex-column row-gap-20">
              <label>Inicie um atendimento padrão</label>
              <Col md={6} className="d-flex flex-column">
                <label className="label-12">CPF do cliente</label>
                <InputCustom
                  type="text"
                  placeholder="Digite aqui"
                  onChange={(e) => {
                    dispatch(inicioActions.setCpfAtendimento(e.target.value))
                  }}
                  onBlur={() => {
                    dispatch(
                      inicioActions.setCpfAtendimento(
                        maskCPF(adicaodeZerosNoCPF(cpfAtendimento))
                      )
                    )
                  }}
                  value={maskCPF(cpfAtendimento)}
                  onKeyDown={handleKeyDown}
                />
              </Col>
              <div
                onClick={() => iniciarAtendimento()}
                className="btn-outline-purple"
              >
                Iniciar <FiChevronsRight />
              </div>
            </div>
          </ContentBoard>
        </Col>
      </Row>
      <SimpleCard>
        <SimpleTitleCard>
          <FiUsers className="icon" /> Sua carteira
        </SimpleTitleCard>
        <LoadingComponent isLoading={loading.carteiras}>
          <div className="d-flex gap-4 flex-wrap">
            {carteiras?.map((centroCusto) => {
              return (
                <Card
                  className="d-flex w-100 flex-column gap-4 p-4"
                  key={`card-${centroCusto.id}`}
                >
                  <div className="d-flex justify-content-between">
                    <h5>{centroCusto.descricao}</h5>
                    <MdOpenInFull
                      role="button"
                      size={20}
                      onClick={() => {
                        toggleCentro(centroCusto.id)
                      }}
                    />
                  </div>
                  <Collapse isOpen={!!openCentro[centroCusto.id]}>
                    <div className="d-flex gap-4 flex-wrap">
                      {centroCusto.consultores?.map((consultor) => {
                        return (
                          <div
                            className="d-flex flex-column gap-4 w-100"
                            key={`consultor-${consultor.id}`}
                          >
                            <div className="linha-horizontal" />
                            <div
                              className="d-flex justify-content-between"
                              key={consultor.id}
                            >
                              <label className="label-12">
                                {consultor.nome}
                              </label>
                              <IconButton
                                onClick={() =>
                                  toggleConsultor(consultor.id, centroCusto.id)
                                }
                              >
                                {openConsultor[
                                  `${centroCusto.id}-${consultor.id}`
                                ] ? (
                                  <BiChevronUp />
                                ) : (
                                  <BiChevronDown />
                                )}
                              </IconButton>
                            </div>
                            <Collapse
                              isOpen={
                                !!openConsultor[
                                  `${centroCusto.id}-${consultor.id}`
                                ]
                              }
                            >
                              <div className="d-flex gap-4 flex-wrap">
                                {consultor.carteirasConsultor?.map(
                                  (carteira) => (
                                    <CardCarteira
                                      key={
                                        carteira.consultorId +
                                        '-' +
                                        carteira.tipoProduto
                                      }
                                      nomeConsultor={consultor.nome}
                                      tipoProduto={carteira.tipoProduto}
                                      produto={carteira.produto}
                                      totalClientes={carteira.totalClientes}
                                      totalClientesAcionar={
                                        carteira.totalClientesAcionar
                                      }
                                      totalClientesNovos={
                                        carteira.totalClientesNovos
                                      }
                                      totalClientesPerdidos={
                                        carteira.totalClientesPerdidos
                                      }
                                      valorOportunidade={
                                        carteira.valorOportunidade
                                      }
                                      consultorId={carteira.consultorId}
                                    />
                                  )
                                )}
                              </div>
                            </Collapse>
                          </div>
                        )
                      })}
                    </div>
                  </Collapse>
                </Card>
              )
            })}
          </div>
        </LoadingComponent>
      </SimpleCard>
      <SimpleCard>
        <SimpleTitleCard>
          <FiShoppingBag className="icon" /> Iniciar um atendimento de campanha
        </SimpleTitleCard>
        <LoadingComponent isLoading={loading.campanhas}>
          {campanhas && campanhas.length > 0 && (
            <ScrollContainer>
              {campanhas.map((campanha, i) => (
                <CardCampanha
                  key={i}
                  id={campanha.id}
                  nomeCampanha={campanha.nomeCampanha}
                  dataInicial={campanha.dataInicio}
                  dataFinal={campanha.dataFim}
                  nomeLoja={campanha.nomeLoja}
                  tipoOperacao={campanha.descricaoTipoOperacao}
                  totalClientes={campanha.totalClientes}
                  totalClientesAcionar={campanha.totalClientesAcionar}
                  cpc={campanha.cpc}
                  conversao={campanha.conversao}
                  ligacoesRecebidas={campanha.ligacoesRecebidas}
                  ligacoesPerdidas={campanha.ligacoesPerdidas}
                  paused={campanha.paused}
                  descricaoTipoCampanha={campanha.descricaoTipoCampanha}
                  codigoCampanhaDiscador={campanha.codigoCampanhaDiscador}
                />
              ))}
            </ScrollContainer>
          )}
        </LoadingComponent>
      </SimpleCard>
    </Main>
  )
}

export default Inicio
